import { render } from "./BaseProjectSearch.vue?vue&type=template&id=1de425af&scoped=true"
import script from "./BaseProjectSearch.vue?vue&type=script&lang=js"
export * from "./BaseProjectSearch.vue?vue&type=script&lang=js"

import "./BaseProjectSearch.vue?vue&type=style&index=0&id=1de425af&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1de425af"]])

export default __exports__